import { AdminModule } from '@modules/auth/models/user-auth.model';
import { FuseNavigation } from '@shared/@fuse/types';

export const nav_blu: FuseNavigation[] = [
    {
        id: 'fund-management',
        title: 'nav.fund_management',
        type: 'collapsable',
        icon: 'payment',
        children: [
            {
                id: AdminModule.Deposit,
                title: 'nav.deposits',
                type: 'item',
                url: '/deposit'
            },
            {
                id: AdminModule.Withdrawal,
                title: 'nav.withdrawal',
                type: 'item',
                url: '/withdrawal'
            }]
    },
    {
        id: AdminModule.Leverage,
        title: 'nav.leverage',
        type: 'item',
        url: '/leverage',
        icon: 'forum'
    }
];
